<template>
  <v-sheet
    style="position: relative;"
  >
    <slot></slot>
  </v-sheet>
</template>

<script>

export default {
  components: {},

  props: {},

  data: () => ({}),

  methods: {},
};
</script>

<style lang="scss">
.bundle {
  position: relative;
  line-height: normal !important;
  min-height: 250px;

  .bundleType {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 10px;
    border-top-left-radius: 2px;
    border-bottom-right-radius: 2px;
    width: auto;
  }

  .status {
    position: absolute;
    right: 46px;
    top: 8px;
  }

  .deleteBundle {
    position: absolute;
    right: 4px;
    top: 4px;
  }

  .productionSystems {
    min-height: 28px;

    span.v-chip {
      font-size: 10px;
      padding: 0 10px;
    }
  }

  .surfaces,
  .trays,
  .productionSystems {
    table {
      th,
      td {
        font-size: 8px !important;
        padding: 6px 0 !important;
      }
    }
  }

  .surfaces {
    table td:not(:first-child) {
      text-align: left;

      i.v-icon {
        visibility: hidden;
      }

      &:hover {
        i.v-icon {
          visibility: visible;
        }
      }
    }
  }
  .infoContainer {
    display: block;
    font-size: 10px;
    line-height: 14px !important;
  }
}
</style>
